






import {Component, Prop, Vue} from "vue-property-decorator"

@Component
export default class ErrorMessage extends Vue {

  @Prop({type: Object}) private errors!: { [key: string]: string[] }
  @Prop({type: String}) private prop!: string

  get errorList() {
    return this.errors.hasOwnProperty(this.prop) ? this.errors[this.prop] : []
  }

}
